// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { partialRight } from 'lodash'
import { reduxForm, Field } from 'redux-form'
import { radioLookupValidator } from 'validators/lookups'
import { assignRadioFamily, assignSuggestValue } from './helpers'
import { Pagination } from '../common'
import clearRadioValues from './clearRadioValues'
import { RadioLookupWrapper } from './styles'
import {
  LabeledInput,
  RadioCompanies,
  RadioModelFamilies,
  RadioModelNumber,
  SelectFromSet,
} from 'components/Form'

const { asyncValidate, validate } = radioLookupValidator

const modulationTypeOptions = [{
  label: 'Fixed',
  value: 'f',
}, {
  label: 'Adaptive',
  value: 'a',
}, {
  label: 'All',
  value: '%',
}]

const architectureOptions = [{
  label: 'Indoor',
  value: 'i',
}, {
  label: 'Outdoor',
  value: 'o',
}, {
  label: 'Split',
  value: 's',
}, {
  label: 'All',
  value: '%',
}]

const inputRowClass = 'display-flex justify-content-between align-items-start flex-wrap-nowrap'

const liw = {
  width: '90%',
}

const idRoot = 'radio-lookup-'
const companyName = 'companyName'
const mn = 'modelNumber'
const rfn = 'radioFamily'

const Form = ({ change, error, form, handleSubmit }) => {
  const dispatch = useDispatch()
  return (
    <form
      id={'radio-lookup'}
      className={'padding-left-1 padding-right-1 heading-font'}>
      { error && <p id={'radio-lookup-error'} className={'width-100 bg-red margin-top-half'}>{error}</p>}
      <RadioLookupWrapper>
        <Field
          className={'radio-code'}
          autoFocus={true}
          component={LabeledInput}
          id={`${idRoot}radio-code`}
          label={'Radio Code'}
          placeholder={'Code'}
          name={'radioCode'} />
        <RadioCompanies
          className={'manufacturer'}
          handleSelection={partialRight(assignSuggestValue, companyName, change)}
          idRoot={idRoot}
          name={companyName} />
        <RadioModelFamilies
          className={'model-family'}
          handleSelection={partialRight(assignRadioFamily, rfn, change)}
          idRoot={idRoot}
          name={`${rfn}Name`} />
        <RadioModelNumber
          className={'model'}
          handleSelection={partialRight(assignSuggestValue, mn, change)}
          idRoot={idRoot}
          name={mn}
          sourceForm={form}/>
        <Field
          className={'emission-bandwidth'}
          component={LabeledInput}
          id={`${idRoot}emission-bandwidth`}
          label={'Emission Bandwidth (MHz)'}
          name={'bandwidth'}
          placeholder={'Number or Min:Max'} />
        <div style={{ marginTop: '38px' }}>
          <button
            className={'radio-lookup-search'}
            id={`${idRoot}submit`}
            className={'btn search-button'}
            onClick={handleSubmit}
            type={'submit'} />
          <button
            type={'button'}
            className={'fa fa-eraser pointer clear-button margin-left-1'}
            id={'clearValues'}
            onClick={() => dispatch(clearRadioValues(form))} />
        </div>

        <Field
          className={'modulation-type'}
          component={SelectFromSet}
          id={`${idRoot}modulation-type`}
          name={'modulationType'}
          options={modulationTypeOptions}
          selectLabel={'Modulation Type'}
          valueKey={'value'} />
        <Field
          className={'modulation-scheme-description'}
          component={LabeledInput}
          id={`${idRoot}modulationSchemeDescription`}
          label={'Modulation'}
          name={'modulationSchemeDescription'}
          placeholder={'Modulation'} />
        <Field
          className={'throughput'}
          component={LabeledInput}
          id={`${idRoot}throughput`}
          label={'Throughput (Mbps)'}
          name={'throughput'}
          placeholder={'Number or Min:Max'} />
        <Field
          className={'tx-power-max'}
          component={LabeledInput}
          id={`${idRoot}power`}
          label={'Power (dBm)'}
          name={'txPowerMax'}
          placeholder={'Number or Min:Max'} />
        <Field
          className={'architecture'}
          component={SelectFromSet}
          id={`${idRoot}architecture-type`}
          name={'architecture'}
          options={architectureOptions}
          selectLabel={'Architecture'}
          valueKey={'value'} />
      </RadioLookupWrapper>
      <Pagination
        idRoot={idRoot}
        sourceForm={form} />
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

export default reduxForm({
  asyncValidate,
  asyncBlurFields: [
    companyName,
  ],
  validate,
})(Form)
